import { z } from 'zod';
// MCQ + True/False question category. CLAUDE.md §11 / TECH_DECISIONS §A.1.
// Order is the rendering order in UI legends; do not reorder without updating the UI.
//
// Session 19AN: added 'logical_reasoning' for 考研 / GMAT-style logic items
// (premise-conclusion validity / weaken / strengthen / assumption / inference).
// Pure enum extension — old data forward-compatible.
export const CATEGORY_VALUES = [
    'framework',
    'fact',
    'causal',
    'strategy',
    'comparison',
    'concept',
    'policy',
    'logical_reasoning',
];
export const CategorySchema = z.enum(CATEGORY_VALUES);
// Display labels (zh) for UI. en label is the value itself capitalized.
export const CATEGORY_LABELS_ZH = {
    framework: '框架',
    fact: '数字/事实',
    causal: '因果',
    strategy: '策略',
    comparison: '对比',
    concept: '概念',
    policy: '政策',
    logical_reasoning: '逻辑推理',
};
//# sourceMappingURL=category.js.map